<template>
  <!--  -->
  <div class="bg-white p-12 m-6 rounded-md border border-gray-400">
    <!--  -->
    <h1 class="text-2xl font-semibold tracking-wider">Verify Shipments</h1>
    <!--  -->

    <!--  -->
    <span class="font-bold mt-6">{{ trackingNumbers.length }} Shipments</span>
    <!--  -->

    <!--  -->
    <div class="relative mt-6">
      <!--  -->
      <div class="border-2 border-dashed border-primary-400 rounded-lg p-8 hover:border-primary-600 transition-colors duration-300" @dragover.prevent @drop.prevent="handleDrop">
        <!--  -->
        <input ref="pdfFile" type="file" accept="application/pdf" @change="handleFileChange" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10" />
        <!--  -->
        
        <!--  -->
        <div class="text-center">
          <!--  -->
          <div v-if="!selectedFile" class="space-y-2">
            <!--  -->
            <i class="fas fa-cloud-upload-alt text-4xl text-gray-400"></i>
            <!--  -->

            <!--  -->
            <h4 class="text-lg font-medium">{{ $t('Drag File') }}</h4>
            <!--  -->

            <!--  -->
            <p class="text-sm text-gray-500">{{ $t('Or Click To Select') }}</p>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="isLoading" class="space-y-2">
            <!--  -->
            <span class="font-bold text-center">Loading...</span>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <div v-if="!isLoading && selectedFile" class="space-y-2">
            <!--  -->
            <p class="font-medium text-primary-600">
              {{ $t('selected_file') }}: <span class="font-bold">{{ selectedFile.name }}</span>
            </p>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <p v-if="error" class="mt-2 text-red-500 text-sm">{{ error }}</p>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <TagsInput class="mt-6" :tags="trackingNumbers" @update:tags="updateTags" />
    <!--  -->

    <!--  -->
    <div class="mt-6">
      <!--  -->
      <button @click="handleVerify" class="bg-orange-500 px-4 py-2 text-white outline-none border border-orange-500 focus:border-orange-900 rounded-md hover:bg-orange-600" :class="{ 'pointer-events-none': requestLoading }">
        {{ requestLoading ? 'Processing' : 'Verify Now' }}
      </button>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <div class="relative overflow-x-auto mt-4">
      <!--  -->
      <div>
        <!--  -->
        <div v-for="(items, key, index) in apiResponse" :key="key" class="my-4 shadow">
          <!--  -->
          <div class="flex items-center cursor-pointer bg-gray-200 px-4 py-6 justify-between">
            <!--  -->
            <div class="flex items-center gap-4">
              <!--  -->
              <h2 class=" rounded-t-md ">
                {{ key }}
              </h2>
              <!--  -->

              <!--  -->
              <span class="text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300" :class="{'text-green-100 bg-green-500': key === 'delivered','text-yellow-100 bg-yellow-500': key === 'undelivered','text-red-100 bg-red-500': key === 'notExist',}">
                {{ items.length }}
              </span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <button class="bg-orange-500 text-white px-3 py-2 rounded-md" v-if="key === 'undelivered' && items.length" @click="handleUpdateToPaid" :class="{ 'pointer-events-none': requestLoading }">
              {{ requestLoading ? 'Processing' : 'Change to paid' }}
            </button>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div ref="scrollContainer" @scroll="handleScroll(index)" class="border-gray-400 border" style="height: 250px; overflow-y: auto;">
            <!--  -->
            <table class="w-full whitespace-no-wrap">
              <!--  -->
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <!--  -->
                <tr>
                  <!--  -->
                  <th scope="col" class="px-6 py-3">
                    Tracking Number
                  </th>
                  <!--  -->

                  <!--  -->
                  <th scope="col" class="px-6 py-3">
                    Current Status
                  </th>
                  <!--  -->

                  <!--  -->
                  <th scope="col" class="px-6 py-3">
                    City
                  </th>
                  <!--  -->

                  <!--  -->
                  <th scope="col" class="px-6 py-3">
                    Costs
                  </th>
                  <!--  -->

                  <!--  -->
                  <th scope="col" class="px-6 py-3">
                    Is Paid ?
                  </th>
                  <!--  -->

                  <!--  -->
                  <th scope="col" class="px-6 py-3">
                    Total Price
                  </th>
                  <!--  -->
                </tr>
                <!--  -->
              </thead>
              <!--  -->

              <!--  -->
              <tbody>
                <!--  -->
                <template v-for="item in displayedItems[index]">
                  <!--  -->
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700" v-if="key !== 'notExist'">
                    <!--  -->
                    <th scope="row" style="display: inline-block; line-height: 50px; overflow: hidden; white-space: nowrap; font-family: sans-serif; padding: 0 .5em; text-align: center; width: 100%;" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                      <!--  -->
                      {{ item.trackingNumber }}
                      <!--  -->
                      <small v-if="item.echangeTrack" class="font-bold">(
                        <!--  -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" class="fill-current mr-1 inline">
                          <!--  -->
                          <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 20l-1.359-2.038c-1.061.653-2.305 1.038-3.641 1.038-3.859 0-7-3.14-7-7h2c0 2.757 2.243 5 5 5 .927 0 1.786-.264 2.527-.708l-1.527-2.292h5.719l-1.719 6zm0-8c0-2.757-2.243-5-5-5-.927 0-1.786.264-2.527.708l1.527 2.292h-5.719l1.719-6 1.359 2.038c1.061-.653 2.305-1.038 3.641-1.038 3.859 0 7 3.14 7 7h-2z"></path>
                          <!--  -->
                        </svg>
                        <!--  -->

                        <!--  -->
                        {{ item.echangeTrack }})
                        <!--  -->
                      </small>
                      <!--  -->
                    </th>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      {{ item.status }}
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      {{ item.city }}
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      {{ item.fees }}
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      <!--  -->
                      <span class="text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300" :class="{ 'text-orange-100 bg-orange-500': item.is_paid.toUpperCase() === 'ACCEPT' || item.is_paid.toUpperCase() === 'VALID', 'text-yellow-100 bg-yellow-500': item.is_paid.toUpperCase() !== 'ACCEPT', }">
                        {{ item.is_paid.toUpperCase() === 'ACCEPT' || item.is_paid.toUpperCase() === 'VALID' ? 'Paid' : 'Not Paid' }}
                      </span>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      {{ item.orderObjet.totalPrice }}
                    </td>
                    <!--  -->
                  </tr>
                  <!--  -->

                  <!--  -->
                  <tr v-else class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <!--  -->
                    <th scope="row" style=" display: inline-block; line-height: 50px; overflow: hidden; white-space: nowrap; font-family: sans-serif; padding: 0 .5em; text-align: center; width: 100%;" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                      {{ item }}
                    </th>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      <!--  -->
                      <span class="text-reed-100 bg-red-500 text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300">
                        Not Found
                      </span>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      <!--  -->
                      <span class="text-reed-100 bg-red-500 text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300">
                        Not Found
                      </span>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      <!--  -->
                      <span class="text-reed-100 bg-red-500 text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300">
                        Not Found
                      </span>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      <!--  -->
                      <span class="text-reed-100 bg-red-500 text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300">
                        Not Found
                      </span>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="px-6 py-4 text-center">
                      <!--  -->
                      <span class="text-reed-100 bg-red-500 text-xs font-medium mr-2 px-3 py-1 rounded dark:bg-orange-900 dark:text-orange-300">
                        Not Found
                      </span>
                      <!--  -->
                    </td>
                    <!--  -->
                  </tr>
                  <!--  -->
                </template>
                <!--  -->

                <!--  -->
                <tr v-if="loading[index]">
                  <!--  -->
                  <td colspan="6" class="font-bold text-center">Loading...</td>
                  <!--  -->
                </tr>
                <!--  -->
              </tbody>
              <!--  -->
            </table>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full flex items-center justify-end bg-gray-200 p-2">
            <!--  -->
            <div class="w-full flex items-center justify-between gap-2 text-right whitespace-no-wrap">
              <!--  -->
              <div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">
                <!--  -->
                <span>{{ `${$t('total_brut')} : ` }}</span>
                <!--  -->
                
                <!--  -->
                <span class="text-orange-500">{{ `${calculateTotalBrut(key).toLocaleString()} ` }}</span>
                <!--  -->

                <!--  -->
                <sup class="text-orange-500">(MAD)</sup>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">
                <!--  -->
                <span>{{ `${$t('total_costs')} : ` }}</span>
                <!--  -->
                
                <!--  -->
                <span class="text-red-500">{{ `${calculateTotalCosts(key).toLocaleString()} ` }}</span>
                <!--  -->

                <!--  -->
                <sup class="text-red-500">(MAD)</sup>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">
                <!--  -->
                <span>{{ `${$t('total_net')} : ` }}</span>
                <!--  -->
                
                <!--  -->
                <span class="text-green-500">{{ `${calculateTotalNet(key).toLocaleString()} ` }}</span>
                <!--  -->

                <!--  -->
                <sup class="text-green-500">(MAD)</sup>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import TagsInput from '../components/shipments/TagsInput.vue';
import {
  readTrackingFromPdf,
  verifyShipments,
  updateToPaid,
} from '../services/shipments.service';

export default {
  name: 'VerifyShipments',
  components: { TagsInput },
  data() {
    return {
      requestLoading: false,
      apiResponse: { delivered: [], undelivered: [], notExist: [] },
      loading: [false, false, false],
      displayedItems: [[], [], []],
      itemsPerPage: 20,
      itemsPerPage: 20,
      selectedFile: null,
      isLoading: false,
      error: null,
      trackingNumbers: []
    };
  },
  methods: {
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      if (this.validateFile(file)) {
        this.selectedFile = file;
        this.uploadFile();
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (this.validateFile(file)) {
        this.selectedFile = file;
        this.uploadFile();
      }
    },
    validateFile(file) {
      if (!file) return false;
      
      if (file.type !== 'application/pdf') {
        this.error = this.$t('only_pdf_allowed');
        return false;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.error = this.$t('file_too_large');
        return false;
      }

      this.error = null;
      return true;
    },
    async uploadFile() {
      if (!this.selectedFile) return;

      this.isLoading = true;
      this.error = null;

      try {
        const formData = new FormData();
        formData.append('pdf', this.selectedFile);

        const response = await readTrackingFromPdf(formData);

        if (response.success) {
          const newTrackingNumbers = response.data.map((number) => ({
            label: number,
            indicator: false,
          }));

          this.trackingNumbers = [...this.trackingNumbers, ...newTrackingNumbers];

          this.handleVerify()

          this.selectedFile = null;

        } else {
          throw new Error(response.message || 'Failed to process PDF');
        }
      } catch (error) {
        this.error = error.message || this.$t('processing_error');
      } finally {
        this.isLoading = false;
      }
    },
    calculateTotalBrut(key) {
      const items = this.apiResponse[key];

      if (Array.isArray(items)) {
        return items.reduce((total, item) => {
          if (item.orderObjet && item.orderObjet.totalPrice) {
            return total + item.orderObjet.totalPrice;
          }
          return total;
        }, 0);
      }

      return 0;
    },
    calculateTotalBrut(key) {
      const items = this.apiResponse[key];
      if (Array.isArray(items)) {
        return items.reduce((total, item) => {
          if (item.orderObjet && item.orderObjet.totalPrice) {
            return total + item.orderObjet.totalPrice;
          }
          return total;
        }, 0);
      }
      return 0;
    },
    calculateTotalCosts(key) {
      const items = this.apiResponse[key];
      if (Array.isArray(items)) {
        return items.reduce((total, item) => {
          if (item.fees) {
            return total + item.fees;
          }
          return total;
        }, 0);
      }
      return 0;
    },
    calculateTotalNet(key) {
      const totalBrut = this.calculateTotalBrut(key);
      const totalCosts = this.calculateTotalCosts(key);
      return totalBrut - totalCosts;
    },
    handleScroll(index) {
      const container = this.$refs.scrollContainer[index];

      const bottomOfContainer =
        container.scrollHeight - container.clientHeight - container.scrollTop;

      if (bottomOfContainer < 50 && !this.loading[index]) {
        this.loadMore(index);
      }
    },
    loadMore(index) {
      this.loading[index] = true;

      setTimeout(() => {
        const startIndex = this.displayedItems[index].length;
        const newItems = this.apiResponse[
          Object.keys(this.apiResponse)[index]
        ].slice(startIndex, startIndex + this.itemsPerPage);

        this.displayedItems[index].push(...newItems);

        this.loading[index] = false;
      }, 1000);
    },
    updateTags(updatedTags) {
      this.trackingNumbers = updatedTags;
    },
    async handleVerify() {
      this.requestLoading = true;

      this.displayedItems = [[], [], []];

      if (this.trackingNumbers.length) {
        this.apiResponse = (
          await verifyShipments(this.trackingNumbers)
        ).content;

        this.loadMore(0);

        this.loadMore(1);

        this.loadMore(2);
      }

      this.requestLoading = false;
    },
    async handleUpdateToPaid() {
      this.requestLoading = true;

      const result = await updateToPaid(this.apiResponse.undelivered);

      if (result && result.content) {
        this.$toast('Updated Successfully');

        await this.handleVerify();
      } else {
        this.$toast.error('Something went wrong while updating');
      }

      this.requestLoading = false;
    },
  },
};
</script>
